const searchContainer = document.querySelector('.search');
const searchField = document.querySelector('.search__field');